var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7998 8.23926V20.3398H8.21882V15.5344L11.4361 20.3398H15.569L11.3001 13.9911H8.21882V8.23926H4.7998Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7516 3.2002L16.6566 14.4631L15.6469 12.5586C15.6469 12.5586 14.9739 11.3384 14.4198 10.7853L10.0213 15.8461L7.44434 13.6064L11.8433 8.54509C11.2191 8.07239 9.91698 7.57679 9.91698 7.57679L7.89072 6.8424L18.7516 3.2002Z",
    fill: "#E3007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/키움증권-24.cbe32cb036d7a83a54093820003c58e9.svg";
export { ForwardRef as ReactComponent };